import { FormikProps } from "formik";
import React, { useState } from "react";
import { MainFormType, StepType } from "./CreateServiceModal";
// import DropoffInformation from "./CurbsidePickup/DropoffInformation";
import OrderInformation from "./InstorePickup/OrderInformation";
// import PickupInformation from "./CurbsidePickup/PickupInformation";

interface PackagePickupProps {
  form: FormikProps<MainFormType>; // The main form from CreateServiceModal
  setStep: (step: StepType) => void;
}

const CurbsidePickup = ({ form, setStep }: PackagePickupProps) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleOrderInformationSubmit = () => {
    console.log("handle order information submit called!");
    // event.preventDefault();
    // Validate order information fields
    const orderErrors: any = {};
    const orderInfo = form.values.instore_pickup_meta.orderInformation;

    if (!orderInfo.orderNumber)
      orderErrors.orderNumber = "This field is required";
    if (!orderInfo.storeName) orderErrors.storeName = "This field is required";
    if (!orderInfo.proofOfPurchase)
      orderErrors.proofOfPurchase = "This field is required";

    if (Object.keys(orderErrors).length === 0) {
      setIsLoading(true)
      setTimeout(() => {
        setIsLoading(false)
        setStep("pickup");
      }, 300)
    } else {
      // Set touched and errors for order information fields
      form.setTouched({
        ...form.touched,
        instore_pickup_meta: {
          ...form.touched.instore_pickup_meta,
          orderInformation: {
            orderNumber: true,
            storeName: true,
            proofOfPurchase: true,
          },
        },
      });

      form.setErrors({
        ...form.errors,
        instore_pickup_meta: {
          ...form.errors.instore_pickup_meta,
          orderInformation: orderErrors,
        },
      });
    }

    console.log(orderErrors, "orderErrors");
  };

  return (
    <div>
      <OrderInformation form={form} onSubmit={handleOrderInformationSubmit} isLoading={isLoading} />
    </div>
  );
};

export default CurbsidePickup;
